/**
 * Devices
 * Devices
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Text, 1 = Keyword, 2 = Date, 3 = Number, 4 = Boolean, 5 = Object, 6 = KeywordCollection, 7 = GeoPoint
 */
export enum SearchFieldType {
    Text = 'text',
    Keyword = 'keyword',
    Date = 'date',
    Number = 'number',
    Boolean = 'boolean',
    Object = 'object',
    KeywordCollection = 'keywordcollection',
    GeoPoint = 'geopoint'
}

